import Parseable from '@/models/Parseable';

export default class Customer extends Parseable {

    public id!: string;
    public name!: string;
    public street!: string;
    public houseNo!: string;
    public additionalStreet!: string;
    public zipCode!: number;
    public city!: string;
    public country!: string;

    public contactPersons!: string[];

    /**
     * Turns a plain object to a class object
     * @param object
     */
    public static parseFromObject(object: Partial<Customer>): Customer {
        const customer = new Customer();
        Object.assign(customer, object);
        return customer;
    }

    parseToObject(): any {
        const tmp: any = { ...this };
        return tmp;
    }
}
